const domainApi = `mxh666.com`
const domainCdn = `mxh666.com`

export default {
  // 系统名称
  systemName: "Light Tower",

  // 令牌存储名
  tokenName: "TOKEN",

  // 登录前主页
  defaultURL: "/",

  // 主页
  homeURL: `/goods`,

  // 上传
  upload: {
    qiniu: {
      putExtra: {
        mimeType: null
      },
      config: {
        useCdnDomain: true,
        region: `z2`
      }
    }
  },

  cdn: {
    image: `https://image.${domainCdn}`
  },

  // 请求
  request: {
		production: {
      protocol: "https://",
			node: {
				api: "sh.api"
			}
		},
		development: {
			protocol: "http://",
			node: {
				api: "shdev.api"
			}
		}
  },

  // 域名
  domain: domainApi
}